/**
 * @file src/_modulos/prenota/tabela/layouts/config/content/colors.ts
 * @description Configuração simplificada de cores para as tabs
 *
 * Princípios aplicados:
 * - KISS: Configurações simples e diretas
 * - SRP: Apenas gerencia cores
 * - YAGNI: Remove paletas complexas não utilizadas
 */

/**
 * Configuração de cores para cada tab
 */
export const TAB_COLORS = {
  todas: {
    name: "todas",
    primary: "indigo",
    icon: "text-indigo-500",
    text: "text-indigo-600",
    line: "bg-indigo-500",
  },
  minhas: {
    name: "minhas",
    primary: "lime",
    icon: "text-lime-500",
    text: "text-lime-600",
    line: "bg-lime-500",
  },
  pendente: {
    name: "pendente",
    primary: "amber",
    icon: "text-amber-500",
    text: "text-amber-600",
    line: "bg-amber-500",
  },
  revisao: {
    name: "revisao",
    primary: "rose",
    icon: "text-rose-500",
    text: "text-rose-600",
    line: "bg-rose-500",
  },
  sem_boleto: {
    name: "sem_boleto",
    primary: "fuchsia",
    icon: "text-fuchsia-400",
    text: "text-fuchsia-500",
    line: "bg-fuchsia-400",
  },
} as const;

/**
 * Array ordenado das configurações de cores
 */
export const TAB_COLORS_ARRAY = [
  TAB_COLORS.todas,
  TAB_COLORS.minhas,
  TAB_COLORS.pendente,
  TAB_COLORS.revisao,
  TAB_COLORS.sem_boleto,
] as const;

/**
 * Tipos para as cores das tabs
 */
export type TabColorKey = keyof typeof TAB_COLORS;
export type TabColorConfig = (typeof TAB_COLORS)[TabColorKey];

/**
 * Função para obter a configuração de cor por índice
 */
export function getTabColorByIndex(index: number): TabColorConfig {
  return TAB_COLORS_ARRAY[index] || TAB_COLORS.todas;
}

/**
 * Função para obter a configuração de cor por nome
 */
export function getTabColorByName(name: string): TabColorConfig {
  return TAB_COLORS[name as TabColorKey] || TAB_COLORS.todas;
}
